export default __webpack_public_path__ + "static/dogs-trust-339e0b5d2462ed939f2316d89a2efd8b.jpg";